import styled from "@emotion/styled";
import { Instant } from "@js-joda/core";
import React, { ReactElement } from "react";
import { VisitBroadcastId } from "../../messages/ObjectIds";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { VisitPendingConfirmationCountdown } from "./VisitPendingConfirmationCountdown";
import MainV2TopBanner from "../MainV2Screen/components/MainV2TopBanner";
import { CHEVRON_RIGHT_ICON } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";

interface Props {
  visitId: VisitBroadcastId;
  pendingConfirmationUntil: Instant;
  pendingConfirmationConfirmedAt: Instant | null;
  onShowDetailsClick: (visitId: VisitBroadcastId, isReviewOnly: boolean) => void;
  onTimerEnd: () => void;
}

export function VisitPendingConfirmationBannerV2(props: Props): ReactElement {
  const isConfirmedVisit = props.pendingConfirmationConfirmedAt !== null;
  const displayTexts = isConfirmedVisit
    ? {
        countdownHeaderText: translate(STRINGS.WE_GOT_YOUR_CONFIRMATION),
        countdownText: translate(STRINGS.THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION),
        buttonText: translate(STRINGS.DETAILS),
      }
    : {
        countdownHeaderText: translate(STRINGS.YAY_YOU_WERE_ASSIGNED_TO_A_VISIT),
        countdownText: translate(STRINGS.YOU_HAVE_HH_MM_TO_CONFIRM_IT),
        buttonText: translate(STRINGS.CONFIRM),
      };

  return (
    <Root>
      <BannerTextContainer>
        <BannerHeader>{displayTexts.countdownHeaderText}</BannerHeader>
        <VisitPendingConfirmationCountdown
          text={displayTexts.countdownText}
          pendingConfirmationUntil={props.pendingConfirmationUntil}
          onTimerEnd={props.onTimerEnd}
        />
      </BannerTextContainer>
      <Button onClick={() => props.onShowDetailsClick(props.visitId, isConfirmedVisit)}>
        <span>{displayTexts.buttonText}</span>
        <AppIcon icon={CHEVRON_RIGHT_ICON} fill="var(--primary-color)" size={12} />
      </Button>
    </Root>
  );
}

const BannerHeader = styled.p`
  font-weight: 800;
  margin: 0;
`;

const BannerTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Root = styled(MainV2TopBanner)`
  background-color: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 74px;
  box-sizing: border-box;
  padding: 12px 16px;
`;

const Button = styled.button`
  padding: 10px;
  border: 1px solid white;
  background-color: white;
  border-radius: 32px;
  color: var(--primary-color);
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  width: 30%;
  justify-content: center;

  .AppIcon {
    margin-left: 4px;
    margin-top: 2px;
  }
`;
